import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { DocumentRepository } from '../application/DocumentRepository'

export function createResilientDocumentRepository(
  primary: DocumentRepository,
  fallback: DocumentRepository,
): DocumentRepository {
  return {
    async listForEntity(query) {
      try {
        return await primary.listForEntity(query)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'documents', operation: 'list', fallback: true })
        const result = await fallback.listForEntity(query)
        return {
          ...result,
          meta: {
            ...result.meta,
            source: 'fixture-fallback',
            fallbackReason: 'DOCUMENTS_REMOTE_UNAVAILABLE',
          },
        }
      }
    },
    // Un téléchargement n'a aucun repli : sans archive réelle, il n'y a rien à signer.
    createDownloadUrl(storagePath, bucket) {
      return primary.createDownloadUrl(storagePath, bucket)
    },
    // Un téléversement n'a aucun repli non plus : rien à archiver sans Supabase.
    uploadClientDocument(command) {
      return primary.uploadClientDocument(command)
    },
    uploadPaymentDocument(command) {
      return primary.uploadPaymentDocument(command)
    },
  }
}
